/* eslint-disable react/no-array-index-key */
import { Highlight, themes } from 'prism-react-renderer';
import { twJoin } from 'tailwind-merge';

import SocialButton from 'molecules/Button/Social';
import { CodeBlockFields } from 'molecules/CodeBlock/config';

import type { FC } from 'react';

const CodeBlock: FC<CodeBlockFields> = ({ language, code }) =>
  code && (
    <Highlight language={language} code={code} theme={themes.jettwaveDark}>
      {({ tokens, getLineProps, getTokenProps }) => (
        <div className="relative">
          <pre className="flex overflow-hidden rounded-xl bg-gray-900 font-robotoMono">
            <div className="flex flex-col border-r border-primary-25 bg-gray-800 p-6">
              {tokens.map((_, i) => (
                <span key={i} className="text-gray-400">
                  {i + 1}
                </span>
              ))}
            </div>
            <div
              className={twJoin(
                'no-scrollbar flex flex-col overflow-auto p-6',
                language === 'txt' && 'whitespace-normal',
              )}
            >
              {tokens.map((line, i) => (
                <div key={i} {...getLineProps({ line })}>
                  {line.map((token, key) => (
                    <span key={key} {...getTokenProps({ token, key })} />
                  ))}
                </div>
              ))}
            </div>
          </pre>
          <div className="dark absolute right-4 top-4">
            <SocialButton
              icon="copy"
              onClick={() => {
                navigator.clipboard.writeText(code);
              }}
            />
          </div>
        </div>
      )}
    </Highlight>
  );
export default CodeBlock;
